import {Fragment} from 'react'
import { NextSeo, ArticleJsonLd } from "next-seo";
import Layout from "@/src/layout/Layout";
import { client, urlFor } from "../lib/client";
import BlockContent from "@sanity/block-content-to-react";
import Image from 'next/image';
const Home = ({
    fetchFooter,
    fetchHeader,
    fHeaderMenuData,
    fetchData,

}) => {
    const { seo, body } = fetchData;
    const {jsonLtd, metaDescription, metaTitle, seo_image,type  } = seo;

    console.log(seo)
  return (
    <Fragment>
      <NextSeo
            title={metaTitle}
            description={metaDescription}
            canonical="/projects"
            robots="index, follow"
            openGraph={{
              type: type,
              url: "/projects",
              title: metaTitle,
              description: metaDescription,
              image: urlFor(seo_image).url(),
            }} 
        />
        <ArticleJsonLd
     dataArray={JSON?.parse(jsonLtd)}
        />
      <Layout
        footerData={fetchFooter}
        headerData={fetchHeader}
        menuData={fHeaderMenuData}
      >
        <section className="blog-details-page py-130 rpy-100 rel z-1">

<div className="container container-1290">
  <div className="row gap-60">
  <h1 className="hero-title mb-100 rmb-50 wow fadeInUp delay-0-2s">
Terms & Conditions
</h1>
    <div className="col-lg-12">
      <div className="blog-single-content">
        {/* blog start here */}
         <BlockContent
          blocks={body}
          projectId="82wyjz97"
          dataset="production"

          serializers={{
            types: {
              dualImage: (props) => {
                return (
                  <div className="row mt-50 pb-20">
                  <div className="col-md-6">
                    <div className="image mb-30 wow fadeInUp delay-0-2s">
                    <img src={urlFor(props.node.image1)} alt="Image 1" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="image mb-30 wow fadeInUp delay-0-4s">
                    <img src={urlFor(props.node.image2)} alt="Image 2" />
                    </div>
                  </div>
                </div>
                );
              },
              blockQuote: (props) => {
                return (
                  <div className="py-30">
                  <blockquote>
                  {props.node.text}
                   <span className="blockquote-footer"> {props.node.paragraph} </span>
                 </blockquote>
                 </div>
                );
              },
              block: (props) => {
                switch (props.node.style) {
                  case "h1":
                    return (
                      <h1
                        initial={{ x: -100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.75 }}
                        className="text-4xl font-bold py-3"
                      >
                        {props.children}
                      </h1>
                    );
                  case "h2":
                    return (
                      <h2
                       
                        className="text-4xl font-bold py-3"
                      >
                        {props.children}
                      </h2>
                    );
                  case "h3":
                    return (
                      <h3 className="text-2xl font-semibold py-3">
                        {props.children}
                      </h3>
                    );
                  case "h4":
                    return (
                      <h4 className="text-xl font-semibold">
                        {props.children}
                      </h4>
                    );
                  case "h5":
                    return (
                      <h5 className="text-lg font-semibold ">
                        {props.children}
                      </h5>
                    );
                  case "h6":
                    return (
                      <h6 className="text-base font-semibold ">
                        {props.children}
                      </h6>
                    );
                  case "image":
                    return (
                      <div className="image mb-155 rmb-100 wow fadeInUp delay-0-2s">
                      <Image  alt={seo.metaTitle} className="" src={props.children} />
                      </div>
                    );
                    case "dualImage":
                      return (
                        <div className="row mt-50 pb-20">
                        <div className="col-md-6">
                          <div className="image mb-30 wow fadeInUp delay-0-2s">
                          <img src={urlFor(props.node.image1)} alt="Image 1" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="image mb-30 wow fadeInUp delay-0-4s">
                          <img src={urlFor(props.node.image2)} alt="Image 2" />
                          </div>
                        </div>
                      </div>
                       
                      );
                  
                    case "firstText":
                      return (
                        <p className="big-first-letter">
                        {props.children}
                        </p>
                      );
                    
                  default:
                    return (
                      <p>
                        {props.children}
                      </p>
                    );
                }
              },
            },
          }}
        />
     
      </div>
    </div>
  </div>
</div>
</section>

        </Layout>
        </Fragment>
  )
}


export const getServerSideProps = async () => {

    const query = `*[_type == "termsAndConditions"][0]`;
    const fetchData = await client.fetch(query);

    const queryForFooter = `*[ _type == "Footer"  ][0]`;
    const fetchFooter = await client.fetch(queryForFooter);
  
    const queryForHeader = `*[ _type == "Header"  ][0]`;
    const fetchHeader = await client.fetch(queryForHeader);
  
    // fetching header data
    const headMenuData = `*[ _type == "Header"  ]{
            menu_items[]->{
                     title,
                     slug,
                     menu_name,
                     menu_name_number,
           }
         }[0]`;
    const fHeaderMenuData = await client.fetch(headMenuData);
    const headerDataForMenu = fHeaderMenuData.menu_items;
    // All data
    return {
      props: {
        fetchData,
        fetchFooter,
        fetchHeader,
        fHeaderMenuData: headerDataForMenu,
      },
    };
  };

export default Home